export default class Dates {
  static parseISO(raw) {
    if (!raw) {
      return null;
    }
    const [day, month, year] = raw.split('/');
    return `${year}-${month}-${day}`;
  }

  static fromISO(raw) {
    if (!raw) {
      return null;
    }
    const [year, month, day] = raw.split('-');
    return `${day}/${month}/${year}`;
  }
}
